export default __webpack_public_path__ + "static/media/IMG2071.ec4fb8a7.jpg";